<template>
  <section class="activity-section">
    <div class="controls">
      <label>{{ $t('日期') }} <input type="date" v-model="date" :max="today" @change="load" /></label>
      <van-button size="small" :loading="loading" @click="load">{{ $t('刷新') }}</van-button>
    </div>
    <p v-if="loading" role="status">{{ $t('加载中') }}</p>
    <div v-else-if="error" role="alert"><p>{{ $t('运动记录加载失败') }}</p><van-button size="small" @click="load">{{ $t('重试') }}</van-button></div>
    <p v-else-if="!supported" class="empty">{{ $t('设备不支持运动历史') }}</p>
    <template v-else>
      <activity-chart :records="records" field="stepCount" :title="$t('步数')" :unit="$t('步')" />
      <activity-chart :records="displayRecords" field="exerciseDurationMinutes" :title="$t('运动时间')" :unit="$t('分钟')" />
    </template>
  </section>
</template>
<script>
import {Button} from 'vant'
import {getActivityHistory} from '@/api/device'
import {getImei} from '@/util/session-storage-utils'
import ActivityChart from './ActivityChart.vue'
const shanghaiDate = () => new Date(Date.now() + 8 * 3600000).toISOString().slice(0, 10)
export default {
  components: {ActivityChart, [Button.name]: Button},
  data() { return {supported: false, records: [], date: shanghaiDate(), today: shanghaiDate(), loading: false, error: false, requestId: 0} },
  created() { this.load() },
  beforeDestroy() { this.requestId++ },
  watch: {
    '$route.query._imei'() { this.records = []; this.load() }
  },
  computed: {
    displayRecords() {
      return this.records.map(row => ({...row, exerciseDurationMinutes: row.exerciseDurationSeconds == null
        ? null : Math.round(row.exerciseDurationSeconds / 60 * 100) / 100}))
    }
  },
  methods: {
    async load() {
      const requestId = ++this.requestId
      const imei = this.$route.query._imei || getImei()
      this.loading = true
      this.error = false
      try {
        const startTime = Date.parse(this.date + 'T00:00:00+08:00')
        if (!Number.isFinite(startTime)) throw new Error('Invalid date')
        const params = {startTime, endTime: startTime + 86400000, limit: 1000}
        let records = [], more = true
        while (more) {
          const response = await getActivityHistory(imei, params)
          if (requestId !== this.requestId) return
          const data = response.data
          this.supported = data.supported
          records = records.concat(data.records || [])
          more = data.hasMore
          if (more && (!data.nextCursor || data.nextCursor === params.after)) throw new Error('Invalid cursor')
          params.after = data.nextCursor
        }
        this.records = records
      } catch (e) {
        if (requestId !== this.requestId) return
        // Allow retry even when the initial capability request fails.
        this.supported = true
        this.error = true
      } finally { if (requestId === this.requestId) this.loading = false }
    }
  }
}
</script>
<style scoped>
.activity-section { margin: 12px; padding: 16px 0 4px; background: white; border-radius: 12px; font-size: 14px; line-height: 1.5; }
.controls { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px; padding: 0 16px; }
.controls label { display: flex; align-items: center; font-size: 14px; min-width: 0; }
.controls input { width: 140px; max-width: 100%; min-width: 0; margin-left: 8px; padding: 6px; border: 1px solid #dcdee0; border-radius: 6px; box-sizing: border-box; background: #fff; color: #323233; font-size: 14px; line-height: 20px; }
p { padding: 0 16px; font-size: 14px; }
.empty { padding: 32px 16px; text-align: center; color: #969799; }
</style>
